import React from "react";

const StepMessage = props => {
  return (
    <>
      <div className="d-inline row">
        <h1 className="primaryColor pr-2 pl-3 d-inline">{props.stepNumber}</h1>
        <h4 style={{ textAlign: "center" }} className="primaryColor d-inline">
          {props.stepText}
        </h4>
      </div>
      <div style={{ background: "#3853A4" }} className="row card text-white">
        <div className="card-body">
          <div className="card-text">{props.children}</div>
        </div>
      </div>
    </>
  );
};

export default StepMessage;
